<script>
    import External from "./External.svelte";
</script>

<style lang="less">
    @import '../common.less';
    div {
        margin: 30px 0;
    }
    .desktop({
        div {
            display: grid;
            grid-template-areas: "n0 . n1 . n2 . n3";
            grid-template-columns: 1fr 15px 1fr 15px 1fr 15px 1fr;
            grid-template-rows: 1fr;
        }
    });
    .mobile({
        div {
            max-width: 400px;
            display: grid;
            grid-template-areas: "n0 . n1" ". . ." "n2 . n3";
            grid-template-rows: 1fr 15px 1fr;
            grid-template-columns: 1fr 15px 1fr;
        }
    });
</style>

<div>
    <External style="grid-area: n0; margin: 0; max-width: none;" width={100} height={100} url={"/worker.svg"}/>
    <External style="grid-area: n1; margin: 0; max-width: none;" width={100} height={100} url={"/callcenterrep.svg"}/>
    <External style="grid-area: n2; margin: 0; max-width: none;" width={100} height={100} url={"/hrmanager.svg"}/>
    <External style="grid-area: n3; margin: 0; max-width: none;" width={100} height={100} url={"/ceo.svg"}/>
</div>